module.exports = __webpack_public_path__ + "img/3.a027ccf9.png";